import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ChartCard } from '../../models/charts';
import { chartCardList } from '../../models/chart-data';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ChartDataService } from '../../services/chart-data.service';
import { QueryRecord, ChartMetadata } from '../../../../API';

@Component({
  selector: 'app-chart-details',
  templateUrl: './chart-details.component.html',
  styleUrl: './chart-details.component.scss',
})
export class ChartDetailsComponent implements OnInit {
  @Output() backEvent: EventEmitter<void> = new EventEmitter<void>();

  chartCards: ChartCard[] = chartCardList;
  chartDetails: FormGroup;
  selectedChart: ChartCard = chartCardList[0];
  queryRecord: QueryRecord | null = null;
  chartMetadata: ChartMetadata | null = null;
  isEditMode: boolean = false;
  isViewMode: boolean = false;

  constructor(
    private fb: FormBuilder,
    public chartDataService: ChartDataService,
  ) {
    this.chartDetails = this.fb.group({
      name: this.fb.control('', [Validators.required, Validators.maxLength(30)]),
      description: this.fb.control('', [Validators.required, Validators.maxLength(120)]),
      chartType: this.fb.control({ value: '', disabled: false }, [Validators.required]),
      queryId: this.fb.control({ value: '', disabled: false }, [Validators.required]),
      athenaExecutionId: this.fb.control({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.chartTypeFormControl.valueChanges.subscribe((newValue) => {
      this.selectedChart = this.chartCards.find((chart) => chart.type === newValue)!;
    });

    this.chartMetadata = this.chartDataService.chartMetadata;
    this.queryRecord = this.chartDataService.queryRecord;
    this.isEditMode = !!this.chartMetadata;
    this.isViewMode = this.chartDataService.isViewMode;

    if (this.chartMetadata) {
      this.chartDetails.patchValue({
        name: this.chartMetadata.name || '',
        description: this.chartMetadata.description || '',
        chartType: this.chartMetadata.chartType,
        queryId: this.chartMetadata.queryId || '',
        athenaExecutionId: this.chartMetadata.athenaExecutionId || '',
      });

      const existingChartCard = this.chartCards.find((chart) => chart.type === this.chartMetadata?.chartType);
      if (existingChartCard) {
        this.selectedChart = existingChartCard;
        this.chartTypeFormControl.setValue(this.chartMetadata.chartType);
      }
    } else if (this.queryRecord) {
      this.chartDetails.patchValue({
        queryId: this.queryRecord.queryId,
        athenaExecutionId: this.queryRecord.athenaExecutionId,
      });
    }
  }

  selectChartType(value: string) {
    this.chartTypeFormControl.setValue(value);
  }

  back() {
    this.backEvent.emit();
  }

  onTypeAvailability(isAvailable: boolean) {
    if (!isAvailable) {
      this.chartTypeFormControl.disable({ emitEvent: false });
    } else {
      this.chartTypeFormControl.enable({ emitEvent: false });
    }
  }

  onChartCardsValidated(): void {
    const activeChart = this.chartCards.find((card) => !card?.disabled);
    activeChart && this.chartTypeFormControl.setValue(activeChart.type);
  }

  get chartTypeFormControl(): UntypedFormControl {
    return this.chartDetails.get('chartType') as UntypedFormControl;
  }

  isCardDisabled(card: ChartCard) {
    return this.chartTypeFormControl.disabled || this.isEditMode || card.disabled;
  }
}
